import { client } from '../client';
import { calendarUrl } from './utils';

export interface Calendar {
  calendarId: string;
  calendarName: string;
  timeZone?: string;
  calendarDescription?: string;
  primary?: boolean;
}

export interface Calendars {
  calendars: Calendar[];
}

export const getCalendars = (integrationId: number): Promise<Calendars> =>
  client.get(calendarUrl(integrationId));
